module.exports = __webpack_public_path__ + "assets/img/cw图标_u198.e798d694.e798d694.svg";